(ns frontend.ui.component.lp-portal.report.overview.total-investment-chart.controller
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn total-investment
  [chart-data-at-cost]
  (let [data (util/->array-of-tuples chart-data-at-cost :at-cost)]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-me-label-formatter-no-division})))